<template>
  <div>
    <b-row>
      <b-col>
        <b-card no-body class="mb-2 p-2 radius">
          <org-view
            v-if="!loading"
            :orgoData="partnerAllData"
            @reload-partner="reLoadPartnerData"
          ></org-view>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card no-body class="mb-2 p-2 radius">
          <office-view
            v-if="!loading"
            :partnerData="partnerAllData"
            @reload-partner="reLoadPartnerData"
          ></office-view>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card no-body class="mb-2 p-2 radius">
          <bill-view
            v-if="!loading"
            :billData="partnerAllData"
            @reload-partner="reLoadPartnerData"
          ></bill-view>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card no-body class="mb-2 p-2 radius">
          <agreement-view
            v-if="!loading"
            :agreeData="agreementData"
            @reload-partner="reLoadPartnerData"
          ></agreement-view>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card no-body class="mb-2 p-2 radius">
          <credential-view
            v-if="!loading"
            :authData="partnerAllData.authentication"
            @reload-partner="reLoadPartnerData"
          ></credential-view>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card no-body class="mb-2 p-2 radius">
          <additional-view
            v-if="!loading"
            :authData="partnerAllData.authentication"
            @reload-partner="reLoadPartnerData"
          ></additional-view>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import orgView from "@/components/Partner/PartnerView/Organization";
import billView from "@/components/Partner/PartnerView/BillTO";
import agreementView from "@/components/Partner/PartnerView/Agreement";
import credentialView from "@/components/Partner/PartnerView/Credential";
import additionalView from "@/components/Partner/PartnerView/Additional";
import officeView from "@/components/Partner/PartnerView/OfficeView";
import { mapGetters } from "vuex";

export default {
  name: "basic-info",
  components: {
    orgView,
    billView,
    credentialView,
    agreementView,
    officeView,
    additionalView,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      partnerAllData: "partner/GetPartnerData",
      getCategoryList: "catalog/GetCategoryList",
    }),
    agreementData() {
      let data = this.$store.getters["partner/GetPartnerData"];
      return data?.agreement;
    },
  },
  methods: {
    async reLoadPartnerData(id) {
      await this.$store.dispatch("partner/fetchPartnerById", id);
    },
  },
  async mounted() {
    this.loading = true;
    if (this.partnerAllData == null) {
      await this.$store.dispatch(
        "partner/fetchPartnerById",
        this.$route.params.id
      );
    }
    this.loading = false;
  },
};
</script>
<style>
.radius {
  border-radius: 16px;
  border: 1px solid #dee3ea;
}
.btn.focus,
.btn:focus {
  box-shadow: none !important;
}
/* Align section header icons (pencil/edit) in same column - fixed right column */
.radius >>> .section-header-row {
  flex-wrap: nowrap;
}
.radius >>> .section-header-row h3 {
  margin-bottom: 0;
  margin-top: 0;
  line-height: 1.4;
  flex-shrink: 0;
}
.radius >>> .edit_button {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.radius >>> .edit_button .v-avatar,
.radius >>> .edit_button img {
  margin: 0 !important;
}
</style>
